import AgreementForm from "./components/AgreementTerms/AgreementForm";
import CreateContent from "./pages/createContent";
import ComplianceModal from "./components/Content/ComplianceModal";
import AgreementFormV2 from "./components/AgreementTerms/AgreementFormV2";
export const API_KEY = "9573be62dd65ba2d016f1a50";
export const EXCHANGE_RATE_URL = `https://v6.exchangerate-api.com/v6/${API_KEY}/latest/USD`;
export const costOfPreRollDurationIfSkippable = 4.167;
export const costOfPreRollDurationIfNotSkippable = 3.33;
export const costOfMidRollDurationIfSkippable = 5;
export const costOfMidRollDurationIfNotSkippable = 4.167;
export const costOfPostRollDurationIfSkippable = 5.83;
export const costOfPostRollDurationIfNotSkippable = 5;
export const WATCH = "WATCH";
export const LISTEN = "LISTEN";
export const READ = "READ";
export const DEVOTION = "DEVOTION";
export const PLAY = "PLAY";
export const VODCAST = "Vodcast";
export const DREAMKIDS = "DreamKids";
export const SHORT_FILM = "Short Film";

export const steps = [
	{ label: "Terms", component: <AgreementFormV2 /> },
	{ label: "Commercial Agreement", component: <AgreementFormV2 /> },
	{ label: "Upload Content", component: <CreateContent /> },
	{ label: "Content Guidelines", component: <CreateContent /> },
	{ label: "Preview", component: <CreateContent /> },
	{ label: "Submit", component: <CreateContent /> },
];

export const currencyOptions = [
	{ label: "USD", value: "USD" },
	{ label: "EUR", value: "EUR" },
	{ label: "GBP", value: "GBP" },
	{ label: "SGD", value: "SGD" },
	{ label: "PKR", value: "PKR" },
	{ label: "AED", value: "AED" },
	{ label: "CNY", value: "CNY" },
	{ label: "AUD", value: "AUD" },
];

//Authentication States
export const AUTHENTICATED = "authenticated";
export const UNAUTHENTICATED = "unauthenticated";

// Content Types
const ContentType = Object.freeze({
	WATCH: WATCH,
	LISTEN,
	READ,
	DEVOTION,
	PLAY,
	// Add other content types as needed
});

// Header definitions specific to each content type
const HeaderDefinitions = Object.freeze({
	[ContentType.WATCH]: {
		types: Object.freeze({
			TITLE: "title",
			DESCRIPTION: "description",
			YEAR: "year",
			GENRE: "genre",
			LANGUAGE: "language",
			DURATION: "duration",
			RATING: "rating",
			PRODUCER: "producer",
			DIRECTOR: "director",
			ACTORS: "actors",
			IMDBRATING: "imdbRating",
			ROTTENTOMATOESRATING: "rottenRating",
		}),
		labels: Object.freeze({
			title: Object.freeze([
				"Title",
				"Name",
				"Movie Name",
				"Show Name",
				"Production Title",

				"Title Name",
			]),
			description: Object.freeze([
				"Synopsis",
				"Description",
				"About",
				"Story",
				"Plot",
				"Storyline",
				"Plot Outline",
				"Summary",
				"Plot Summaries",
			]),
			year: Object.freeze([
				"Year",
				"Release Year",
				"Year of Release",
				"Release Date",
				"Release Dates",
			]),
			genre: Object.freeze(["Genre", "Genres"]),
			language: Object.freeze([
				"Language",
				"Original Language",
				"Audio Language",
				"Languages",
			]),
			duration: Object.freeze([
				"Running Time",
				"Duration",
				"Length",
				"Total Runtime",
				"Film Length",
				"Runtime",
				"Episode Duration",
			]),
			rating: Object.freeze([
				"Maturity Rating",
				"Rating",
				"Content Advisory",
				"Audience Rating",
				"Age Rating",
				"Content Rating",
				"PG Rating",
				"Parental Guidance Rating",
				"Viewing Rating",
				"Certificate Information",
			]),
			producer: Object.freeze([
				"Producer",
				"Creators",
				"Produced By",
				"Produced by",
				"Age Rating",
				"Executive Producer",
				"Film Producer",
				"Producers",
			]),
			director: Object.freeze([
				"Director",
				"Directors",
				"Directed By",
				"Directed by",
				"Filmmaker",
				"Film Director",
			]),
			actors: Object.freeze([
				"Actors",
				"Cast",
				"Starring",
				"Cast and Crew",
				"Cast & Crew",
				"Starcast",
			]),
			imdbRating: Object.freeze(["IMDB Rating", "IMDB"]),
			rottenRating: Object.freeze([
				"Rotten Tomatoes Rating",
				"Rotten Tomatoes",
			]),
			studios: Object.freeze([
				"Studios",
				"Production Company",
				"Film Studio",
				"Movie Studio",
				"Production House",
				"Film Company",
				"Production Companies",
			]),
		}),
	},
	[ContentType.LISTEN]: {
		types: Object.freeze({
			TITLE: "title",
			DESCRIPTION: "description",
			YEAR: "year",
			GENRE: "genre",
			LANGUAGE: "language",
			DURATION: "duration",
			RATING: "rating",
			COMPOSER: "composer",
			ARTIST: "artist",
		}),
		labels: Object.freeze({
			title: Object.freeze([
				"Title",
				"Album Title",
				"Song Name",
				"Name",
				"Album Name",
				"Record Title",
				"Track Title",
				"Single Title",
				"EP Title",
				"Audiobook Title",
				"Audiobook Name",
				"Title Name",
				"Podcast Name",
				"Show Title",
				"Program Name",
			]),
			description: Object.freeze([
				"Synopsis",
				"Description",
				"About",
				"Song Description",
				"Track Description",
				"Overview",
				"Plot",
				"Plot Outline",
				"Summary",
				"Plot Summaries",
				"Summary",
			]),
			year: Object.freeze([
				"Year",
				"Release Year",
				"Year of Release",
				"Release Date",
				"Release Dates",
				"Publication Date",
				"Publishing Date",
				"First Published",
			]),
			genre: Object.freeze(["Genre", "Genres"]),
			language: Object.freeze([
				"Language",
				"Original Language",
				"Audio Language",
				"Languages",
			]),
			duration: Object.freeze([
				"Running Time",
				"Duration",
				"Length",
				"Total Runtime",
				"Runtime",
				"Song Duration",
				"Length",
			]),
			rating: Object.freeze([
				"Maturity Rating",
				"Rating",
				"Content Advisory",
				"Audience Rating",
				"Age Rating",
				"Content Rating",
				"PG Rating",
				"Parental Guidance Rating",
				"Viewing Rating",
				"Certificate Information",
			]),
			composer: Object.freeze([
				"Composer",
				"Musicians",
				"Performers",
				"Composers",
				"Produced by",
				"Writer",
				"Authors",
				"Author",
				"Writers",
				"Novelist",
			]),
			artist: Object.freeze([
				"Artist",
				"Artists",
				"Singers",
				"Vocalists",
				"Singer",
				"Vocalist",
				"Performed by",
				"Narrator",
				"Narrators",
				"Narrating Artist",
				"Narrating Artists",
				"Performer",
				"Performers",
			]),
		}),
	},
	[ContentType.READ]: {
		types: Object.freeze({
			TITLE: "title",
			DESCRIPTION: "description",
			YEAR: "year",
			GENRE: "genre",
			LANGUAGE: "language",
			RATING: "rating",
			AUTHOR: "author",
			PUBLISHER: "publisher",
		}),
		labels: Object.freeze({
			title: Object.freeze([
				"Title",
				"Book Name",
				"Name",
				"Album Name",
				"Title Name",
			]),
			description: Object.freeze([
				"Synopsis",
				"Description",
				"About",
				"Overview",
				"Plot",
				"Plot Outline",
				"Summary",
				"Plot Summaries",
				"Summary",
				"Story",
			]),
			year: Object.freeze([
				"Year",
				"Release Year",
				"Year of Release",
				"Release Date",
				"Release Dates",
				"Publication Date",
				"Publishing Date",
				"First Published",
			]),
			genre: Object.freeze(["Genre", "Genres"]),
			language: Object.freeze([
				"Language",
				"Original Language",
				"Audio Language",
				"Languages",
			]),
			duration: Object.freeze([
				"Running Time",
				"Duration",
				"Length",
				"Total Runtime",
				"Runtime",
				"Song Duration",
				"Length",
			]),
			rating: Object.freeze([
				"Maturity Rating",
				"Rating",
				"Content Advisory",
				"Audience Rating",
				"Age Rating",
				"Content Rating",
				"PG Rating",
				"Parental Guidance Rating",
				"Viewing Rating",
				"Certificate Information",
			]),
			author: Object.freeze([
				"Author",
				"Authors",
				"Writer",
				"Story By",
				"Story by",
				"Writers",
				"Novelist",
			]),
			publisher: Object.freeze([
				"Publisher",
				"Publication House",
				"Publishing House",
				"Publications",
				"Publishing Company",
			]),
		}),
	},
	[VODCAST]: {
		types: Object.freeze({
		  TITLE: "title",
		  DESCRIPTION: "description",
		  YEAR: "year",
		  GENRE: "genre",
		  LANGUAGE: "language",
		  DURATION: "duration",
		  RATING: "rating",
		  DIRECTOR: "director",
		  PRODUCER: "producer",
		  HOST: "host",
		  GUESTS: "guests",
		  IMDBRATING: "imdbRating",
		  ROTTENTOMATOESRATING: "rottenRating"
		}),
		labels: Object.freeze({
		  title: Object.freeze([
			"Title",
			"Name",
			"Episode Name",
			"Show Name",
			"Vodcast Name",
			"Episode Title",
			"Program Title"
		  ]),
		  description: Object.freeze([
			"Synopsis",
			"Description",
			"About",
			"Episode Description",
			"Show Description",
			"Summary",
			"Content",
			"Overview"
		  ]),
		  year: Object.freeze([
			"Year",
			"Release Year",
			"Year of Release",
			"Release Date",
			"Broadcast Date",
			"Aired Date",
			"Publication Year"
		  ]),
		  genre: Object.freeze([
			"Genre",
			"Genres",
			"Category",
			"Categories",
			"Show Type"
		  ]),
		  language: Object.freeze([
			"Language",
			"Original Language",
			"Audio Language",
			"Languages",
			"Spoken Language"
		  ]),
		  duration: Object.freeze([
			"Running Time",
			"Duration",
			"Length",
			"Episode Duration",
			"Runtime",
			"Show Length",
			"Episode Length"
		  ]),
		  rating: Object.freeze([
			"Maturity Rating",
			"Rating",
			"Content Advisory",
			"Audience Rating",
			"Age Rating",
			"Content Rating"
		  ]),
		  director: Object.freeze([
			"Director",
			"Directors",
			"Show Director",
			"Episode Director"
		  ]),
		  producer: Object.freeze([
			"Producer",
			"Producers",
			"Executive Producer",
			"Show Producer",
			"Episode Producer"
		  ]),
		  host: Object.freeze([
			"Host",
			"Hosts",
			"Presenter",
			"Presenters",
			"Anchor",
			"Anchors",
			"Show Host",
			"Main Host"
		  ]),
		  guests: Object.freeze([
			"Guests",
			"Guest Stars",
			"Featured Guests",
			"Special Guests",
			"Episode Guests",
			"Interviewees"
		  ]),
		  imdbRating: Object.freeze([
			"IMDB Rating",
			"IMDB",
			"Internet Movie Database Rating"
		  ]),
		  rottenRating: Object.freeze([
			"Rotten Tomatoes Rating",
			"Rotten Tomatoes",
			"RT Rating"
		  ])
		})
	  },
	  [ContentType.DEVOTION]: {
        types: Object.freeze({
            TITLE: "title",
            DESCRIPTION: "description",
            DURATION: "duration"
        }),
        labels: Object.freeze({
            title: Object.freeze([
                "Title",
                "Name",
                "Devotion Title",
                "Message Title",
                "Sermon Title"
            ]),
            description: Object.freeze([
                "Description",
                "Synopsis",
                "Message",
                "Content",
                "About",
                "Summary",
                "Reflection"
            ]),
            duration: Object.freeze([
                "Duration",
                "Length",
                "Running Time",
                "Total Time",
                "Playing Time"
            ])
        })
    },
	  
	  // Add DreamKids definition
	  [DREAMKIDS]: {
		types: Object.freeze({
		  TITLE: "title",
		  DESCRIPTION: "description",
		  YEAR: "year",
		  GENRE: "genre",
		  LANGUAGE: "language",
		  DURATION: "duration",
		  RATING: "rating",
		  DIRECTOR: "director",
		  EDUCATIONALVALUE: "educationalValue",
		  AGEGROUP: "ageGroup",
		  IMDBRATING: "imdbRating",
		  ROTTENTOMATOESRATING: "rottenRating"
		}),
		labels: Object.freeze({
		  title: Object.freeze([
			"Title",
			"Name",
			"Episode Name",
			"Show Name",
			"DreamKids Name",
			"Episode Title",
			"Program Title",
			"Kids Show Title"
		  ]),
		  description: Object.freeze([
			"Synopsis",
			"Description",
			"About",
			"Episode Description",
			"Show Description",
			"Summary",
			"Content",
			"Overview",
			"Story Description"
		  ]),
		  year: Object.freeze([
			"Year",
			"Release Year",
			"Year of Release",
			"Release Date",
			"Broadcast Date",
			"Aired Date",
			"Publication Year"
		  ]),
		  genre: Object.freeze([
			"Genre",
			"Genres",
			"Category",
			"Categories",
			"Show Type",
			"Content Type"
		  ]),
		  language: Object.freeze([
			"Language",
			"Original Language",
			"Audio Language",
			"Languages",
			"Spoken Language"
		  ]),
		  duration: Object.freeze([
			"Running Time",
			"Duration",
			"Length",
			"Episode Duration",
			"Runtime",
			"Show Length",
			"Episode Length"
		  ]),
		  rating: Object.freeze([
			"Maturity Rating",
			"Rating",
			"Content Advisory",
			"Audience Rating",
			"Age Rating",
			"Content Rating",
			"Parental Rating",
			"Kids Rating"
		  ]),
		  director: Object.freeze([
			"Director",
			"Directors",
			"Show Director",
			"Episode Director"
		  ]),
		  educationalValue: Object.freeze([
			"Educational Value",
			"Learning Value",
			"Educational Content",
			"Educational Purpose",
			"Learning Objectives",
			"Learning Goals",
			"Teaching Points"
		  ]),
		  ageGroup: Object.freeze([
			"Age Group",
			"Target Age",
			"Age Range",
			"Suitable For",
			"Recommended Age",
			"Age Recommendation",
			"Target Audience Age"
		  ]),
		  imdbRating: Object.freeze([
			"IMDB Rating",
			"IMDB",
			"Internet Movie Database Rating"
		  ]),
		  rottenRating: Object.freeze([
			"Rotten Tomatoes Rating",
			"Rotten Tomatoes",
			"RT Rating"
		  ])
		})
	  },
	  [SHORT_FILM]: {
		types: Object.freeze({
		  TITLE: "title",
		  DESCRIPTION: "description",
		  YEAR: "year",
		  GENRE: "genre",
		  LANGUAGE: "language",
		  DURATION: "duration",
		  RATING: "rating",
		  PRODUCER: "producer",
		  DIRECTOR: "director",
		  ACTORS: "actors",
		  IMDBRATING: "imdbRating",
		  ROTTENTOMATOESRATING: "rottenRating",
		}),
		labels: Object.freeze({
		  title: Object.freeze([
			"Title",
			"Name",
			"Short Film Name",
			"Film Name",
			"Production Title",
			"Title Name",
		  ]),
		  description: Object.freeze([
			"Synopsis",
			"Description",
			"About",
			"Story",
			"Plot",
			"Storyline",
			"Plot Outline",
			"Summary",
			"Plot Summaries",
		  ]),
		  year: Object.freeze([
			"Year",
			"Release Year",
			"Year of Release",
			"Release Date",
			"Release Dates",
		  ]),
		  genre: Object.freeze(["Genre", "Genres"]),
		  language: Object.freeze([
			"Language",
			"Original Language",
			"Audio Language",
			"Languages",
		  ]),
		  duration: Object.freeze([
			"Running Time",
			"Duration",
			"Length",
			"Total Runtime",
			"Film Length",
			"Runtime",
		  ]),
		  rating: Object.freeze([
			"Maturity Rating",
			"Rating",
			"Content Advisory",
			"Audience Rating",
			"Age Rating",
			"Content Rating",
			"PG Rating",
			"Parental Guidance Rating",
			"Viewing Rating",
			"Certificate Information",
		  ]),
		  producer: Object.freeze([
			"Producer",
			"Creators",
			"Produced By",
			"Produced by",
			"Executive Producer",
			"Film Producer",
			"Producers",
		  ]),
		  director: Object.freeze([
			"Director",
			"Directors",
			"Directed By",
			"Directed by",
			"Filmmaker",
			"Film Director",
		  ]),
		  actors: Object.freeze([
			"Actors",
			"Cast",
			"Starring",
			"Cast and Crew",
			"Cast & Crew",
			"Starcast",
		  ]),
		  imdbRating: Object.freeze(["IMDB Rating", "IMDB"]),
		  rottenRating: Object.freeze([
			"Rotten Tomatoes Rating",
			"Rotten Tomatoes",
		  ]),
		  studios: Object.freeze([
			"Studios",
			"Production Company",
			"Film Studio",
			"Movie Studio",
			"Production House",
			"Film Company",
			"Production Companies",
		  ]),
		}),
	  },
});

export { ContentType, HeaderDefinitions };
